import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export const BtnBack = () => {
    const navigate = useNavigate();

    return (
        <button
            onClick={() => navigate(-1)}
            className="p-2 rounded-lg hover:bg-slate-800 transition-colors text-slate-400 hover:text-white"
        >
            <FaArrowLeft />
        </button>
    );
};